(function () {
  function initSwipeCarousels() {
    document.querySelectorAll('.undyz-swipe-carousel').forEach(function (carousel) {
      if (carousel.dataset.swipeInit) return;
      carousel.dataset.swipeInit = '1';

      const track = carousel.querySelector('.undyz-swipe-track');
      const dots = carousel.querySelectorAll('.undyz-swipe-dot');
      if (!track || !dots.length) return;

      // Hide scrollbar visually
      track.style.msOverflowStyle = 'none';
      track.style.scrollbarWidth = 'none';

      // Update dots on scroll
      track.addEventListener('scroll', function () {
        const index = Math.round(track.scrollLeft / track.offsetWidth);
        dots.forEach(function (dot, i) {
          dot.style.background = i === index
            ? 'rgba(255,255,255,1)'
            : 'rgba(255,255,255,0.45)';
          dot.classList.toggle('undyz-swipe-dot--active', i === index);
        });
      }, { passive: true });

      // Prevent swipe from triggering the parent <a> link
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = false;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        const dx = Math.abs(e.touches[0].clientX - startX);
        const dy = Math.abs(e.touches[0].clientY - startY);
        if (dx > dy && dx > 5) {
          isDragging = true;
        }
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        if (isDragging) {
          e.stopPropagation();
        }
      });

      // Block click-through to PDP when swiping
      track.addEventListener('click', function (e) {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
          isDragging = false;
        }
      });
    });
  }

  // Init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeCarousels);
  } else {
    initSwipeCarousels();
  }

  // Re-init for dynamically loaded content (infinite scroll, etc.)
  const observer = new MutationObserver(function () {
    initSwipeCarousels();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
